<div class="modal-overlay" [class.open]="isOpen" (click)="onClose()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <button class="close-btn" (click)="onClose()">Close</button>
            <h2 class="modal-title">Upcoming Bills</h2>
            <button class="save-btn" (click)="onSave()">Save</button>
        </div>

        <div class="modal-body">
            <p class="description">
                You can set the amount from which mandatory payments will be displayed.
            </p>

            <div class="form-group">
                <label class="form-label">Minimum Amount</label>
                <div class="amount-input-wrapper">
                    <input type="text" class="amount-input" [(ngModel)]="minimumAmount" placeholder="100.00">
                    <span class="currency-code">INR</span>
                </div>
            </div>

            <div class="quick-amounts">
                <button *ngFor="let amount of quickAmounts" class="quick-amount-btn" (click)="setAmount(amount)">
                    {{ amount }}
                </button>
            </div>
        </div>
    </div>
</div>